/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseConversationMessages } from '../../models/api-response-conversation-messages';
import { PagedRequestMessage } from '../../models/paged-request-message';

export interface ListMessagesPaginated$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  convReference: string;
      body: PagedRequestMessage
}

export function listMessagesPaginated(http: HttpClient, rootUrl: string, params: ListMessagesPaginated$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversationMessages>> {
  const rb = new RequestBuilder(rootUrl, listMessagesPaginated.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('convReference', params.convReference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseConversationMessages>;
    })
  );
}

listMessagesPaginated.PATH = '/v1/api/ui/message/search/{convReference}';
